import { Route, Routes } from 'react-router-dom';

import { useMatter } from '@/hooks/useMatter';

import { CoverageMentionsDebugPage } from './coverage-mentions/CoverageMentionsDebugPage';
import { CoverageOverviewPage } from './CoverageOverviewPage';
import { CreateCoveragePage } from './CreateCoveragePage';
import { EditCoveragePage } from './EditCoveragePage';
import { MergeCoveragePage } from './merge-coverage-entries/MergeCoveragePage';

export const CoverageRoutes = () => {
  const { matterId } = useMatter();
  return (
    <Routes>
      <Route path="/" element={<CoverageOverviewPage matterId={matterId} />} />
      <Route path="/create" element={<CreateCoveragePage />} />
      <Route path="/merge" element={<MergeCoveragePage />} />
      <Route
        path="/mentions-debug"
        element={<CoverageMentionsDebugPage matterId={matterId} />}
      />
      <Route
        path="/:coverage_id"
        element={<CoverageOverviewPage matterId={matterId} />}
      />
      <Route path="/:coverage_id/edit" element={<EditCoveragePage />} />
    </Routes>
  );
};
